import { render, staticRenderFns } from "./SlickItem.vue?vue&type=template&id=ab455c84&"
import script from "./SlickItem.vue?vue&type=script&lang=js&"
export * from "./SlickItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports